<script setup>
  import { computed } from 'vue'

  import FieldValueRenderer from '@/features/settingsManagement/fieldManagement/edit/plugin/FieldValueRenderer.vue'
  import {
    fieldCommonProps,
    normalizeFieldExtraData,
  } from '@/features/settingsManagement/fieldManagement/edit/utils/fieldUtils.js'

  const props = defineProps({
    modelValue: fieldCommonProps.modelValue,
    field: fieldCommonProps.field,
  })

  const selectedOption = computed(() => {
    const extraData = normalizeFieldExtraData(props.field.extraData)
    const options = extraData?.options || []
    return options.find(option => option.value === props.modelValue)
  })

  const selectedOptionLabel = computed(() => selectedOption.value?.label || '-')
</script>

<template>
  <FieldValueRenderer :field="field">
    <template #label>
      <slot name="label">{{ field.key }}</slot></template
    >

    <slot>
      {{ selectedOptionLabel }}
    </slot>
  </FieldValueRenderer>
</template>

<style lang="scss" scoped></style>
